import {
  Mountain,
  BookOpen,
  Palette,
  Plane,
  Activity,
  Heart,
  type LucideIcon,
} from 'lucide-react';
import { ResizedImage } from '@ah/design/mobile';
import type { BucketListCategory, BucketListItem } from '@ah/bucketlist/shared';

export type { BucketListItem } from '@ah/bucketlist/shared';

const CATEGORY_ICON: Record<BucketListCategory, LucideIcon> = {
  adventure: Mountain,
  learning:  BookOpen,
  creative:  Palette,
  travel:    Plane,
  physical:  Activity,
  impact:    Heart,
};

const CATEGORY_LABEL: Record<BucketListCategory, string> = {
  adventure: 'Adventure',
  learning:  'Learning',
  creative:  'Creative',
  travel:    'Travel',
  physical:  'Physical',
  impact:    'Impact',
};

export function bucketListCardTitle(_item: BucketListItem): string {
  return 'Would you like to add this to your bucket list?';
}

export function BucketListCard({ item }: { item: BucketListItem }): JSX.Element {
  const Icon = CATEGORY_ICON[item.category];
  const categoryLabel = CATEGORY_LABEL[item.category];

  return (
    <div className="bg-card rounded-2xl border border-border shadow-sm overflow-hidden">
      {item.imageUrl ? (
        <div className="w-full aspect-video bg-muted overflow-hidden">
          <ResizedImage src={item.imageUrl} renderWidth={384} fallback={false} alt="" className="w-full h-full object-cover" />
        </div>
      ) : null}

      <div className="p-6 space-y-4">
        <div className="flex items-start gap-4">
          {!item.imageUrl && (
            <div className="w-12 h-12 rounded-2xl bg-primary/10 flex items-center justify-center shrink-0">
              <Icon size={24} className="text-primary" />
            </div>
          )}
          <div className="flex-1 min-w-0 space-y-2">
            <span className="inline-block bg-primary/10 text-primary rounded-full px-2 py-0.5 text-[11px] uppercase tracking-wider font-semibold">
              {categoryLabel}
            </span>
            <p className="font-bold text-2xl leading-tight text-foreground">
              {item.label}
            </p>
          </div>
        </div>

        <p className="text-[15px] text-muted-foreground leading-relaxed">
          {item.description}
        </p>
      </div>
    </div>
  );
}
